var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { switchProp } from 'styled-tools';
var inheritStyles = "\n  font-size: inherit;\n  line-height: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n";
export var IconContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 20px;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 20px;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), switchProp('size', {
    mini: function () { return "\n    width: 18px;\n    height: 18px;\n  "; },
    regular: function () { return "\n    width: 24px;\n    height: 24px;\n  "; },
    mega: function () { return "\n    width: 32px;\n    height: 32px;\n  "; }
}), switchProp('variant', {
    outline: function () { return "\n    border: 2px solid var(--background)};\n    background-color: var(--foreground)};\n    "; },
    solid: function () { return "\n    background-color: var(--foreground)};\n    "; }
}), function (_a) {
    var variant = _a.variant, colorMode = _a.colorMode;
    return colorMode === 'night' &&
        variant !== 'ghost' &&
        "\n    border-color: var(--background);\n    background-color: var(--foreground);";
});
export var Icon = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: var(--icon-font);\n  color: inherit;\n  speak: none;\n\n  ", "\n\n  text-transform: none;\n  position: relative;\n  display: flex;\n  justify-content: center;\n\n  ", "\n\n  ", "\n\n\n\n  &::before {\n    display: inline-block;\n    content: '", "';\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  font-family: var(--icon-font);\n  color: inherit;\n  speak: none;\n\n  ", "\n\n  text-transform: none;\n  position: relative;\n  display: flex;\n  justify-content: center;\n\n  ", "\n\n  ", "\n\n\n\n  &::before {\n    display: inline-block;\n    content: '", "';\n    width: 100%;\n    height: 100%;\n  }\n"])), switchProp('size', {
    /* If size === inherit show predefined styles */
    inherit: function () { return inheritStyles; },
    mini: function () { return "\n    font-size: 12px;\n  "; },
    regular: function () { return "\n    font-size: 12px;\n  "; },
    mega: function () { return "\n    font-size: 18px;\n  "; }
}), switchProp('colorMode', {
    day: function () { return "\n      color: var(--foreground);\n    "; },
    night: function () { return "\n      color: var(--background);\n    "; }
}), function (_a) {
    var size = _a.size;
    return Number.isInteger(size) &&
        "\n  font-size: ".concat(size, "px;");
}, function (_a) {
    var icon = _a.icon;
    return icon;
});
export default {};
var templateObject_1, templateObject_2;
